import { useMemo } from 'react';

import { useClients } from '@spotify/plugin-confidence-iam-react';

export function useSortedClients() {
  const { clients, isLoading, error } = useClients({});

  const sortedClients = useMemo(() => {
    return [...(clients ?? [])].sort((a, b) =>
      b.createTime.localeCompare(a.createTime),
    );
  }, [clients]);

  return {
    clients: sortedClients,
    isLoading,
    error,
  };
}
